//#region import
import React, { useEffect, useState } from 'react';

// styling
import { Colors, Spacing } from '_styles';

// redux
import { useSelector } from 'react-redux';
import { selectSelectedConversation } from '_redux/slices/messaging/messaging'
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';

// custom components
import { MessengerProfilePicture } from '_molecules';
import { AirportImage } from '_organisms';
//#endregion

const Message = (props) => {

    const [appMessage, setAppMessage] = useState(false)

    // redux
    const dbUser = useSelector(selectFirebaseInfo);
    const selectedConversationUserId = useSelector(selectSelectedConversation);

    useEffect(() => {
        if (props.message.type == undefined) { setAppMessage(false) } else { setAppMessage(true) }
    }, [props]);


    if (appMessage) {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <div>
                    <MessengerProfilePicture small={true} user={selectedConversationUserId.userId} />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-start', alignSelf: 'flex-start', marginLeft: Spacing.SCALE_8 }}>
                    <p style={{
                        color: 'white', fontWeight: '400', fontSize: 18,
                        padding: Spacing.SCALE_18, borderRadius: 25,
                        textAlign: 'left',
                        marginRight: Spacing.SCALE_48,
                        backgroundColor: Colors.PRM_LIGHT_BLUE,
                    }}>{props.children}</p>
                </div>
            </div>
        )
    }
    else {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-end', marginRight: Spacing.SCALE_8 }}>
                    <p style={{
                        color: 'black', fontWeight: '400', fontSize: 18,
                        padding: Spacing.SCALE_18, borderRadius: 25,
                        textAlign: 'left',
                        marginLeft: Spacing.SCALE_48,
                        backgroundColor: Colors.GRAY_LIGHT,
                    }}>{props.children}</p>
                </div>
                <div>
                    <AirportImage small={true} iata={dbUser.details.authority} />
                </div>
            </div>
        )
    }
};

export default Message;
